import Api from './baseApi';

export default {
    create: (dto) => Api.post('/api/leaves', dto),
    getMyRequests: () => Api.get('/api/leaves/my'),
    cancel: (id) => Api.delete(`/api/leaves/${id}`),
    canManage: () => Api.get('/api/leaves/can-manage'),
    getAdminList: (params) => Api.get(`/api/leaves/admin?${new URLSearchParams(params || {}).toString()}`),
    approve: (id, note) => Api.post(`/api/leaves/${id}/approve`, { note }),
    reject: (id, note) => Api.post(`/api/leaves/${id}/reject`, { note }),
};
